export default {
  SET_USER: (state, payload) => {
    state.user = payload;
  },
  SET_FIREBASE_USER: (state, payload) => {
    state.firebaseUser = payload;
  }
};